import { IModelEntity } from '@pit/core';
import { IDtoAppVersion } from './dto.app.version.interface';
import { IDtoDepot } from './dto.depot.interface';
import { IDtoMandator } from './dto.mandator.interface';
import { IDtoUser } from './dto.user.interface';

export enum DeviceState {

    Unregistered = 1,
    Registered = 2,
    Disabled = 4,
    Active = 8

}

export interface IDtoDevice extends IModelEntity {

    account?: string;
    accountMail?: string;
    imeiNumber?: string;
    phoneNumber?: string;
    simPIN?: string;
    simPUK?: string;

    deviceId?: string;
    deviceState?: DeviceState;
    manufacturer?: string;
    model?: string;
    name?: string;
    platform?: string;
    operatingSystem?: string;
    osVersion?: string;
    serialNumber?: string;
    connectionId?: string;
    fcmToken?: string;
    isOnline?: boolean;
    lastSync?: Date;

    positionLatitude?: number;
    positionLongitude?: number;
    positionTimestamp?: Date;

    batteryIsCharging?: boolean;
    batteryLevel?: number;
    batteryStatusTimestamp?: Date;

    appVersion?: IDtoAppVersion;
    depot?: IDtoDepot;
    mandator?: IDtoMandator;
    user?: IDtoUser;

    deviceStateDescription?: string;

}
